module.exports = __webpack_public_path__ + "img/hubspot-integration.98f1aad8.png";